export const ProductCategories = ['AM', 'OP', 'SK', 'DP', 'OT', 'CN', 'EX', 'TT', 'GE', 'SU', 'ND', 'CU']
export const APP_VERSION = '1.0.6'
export const DRAWER_WIDTH = 240
export const TAX_RATE = 0.05 // 5%
